import React, { Fragment, isValidElement } from 'react';

import Tippy from '@tippyjs/react';
import { PopoverButton as HeadlessPopoverButton } from '@headlessui/react';

import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';

const CustomPopoverTrigger = ({
  closePopover,
  buttonRef,
  onButtonClick,
  dataQa,
  open,
  disabled,
  tooltip,
  isTooltipDark,
  tooltipPlacement,
  customButton,
  customButtonTrigger,
  customButtonWrapperClassName,
  customButtonClassName,
  setIsOpen,
  onOpen
}) => {
  const renderProps = { open, setIsOpen, closePopover };
  const button = typeof customButton === 'function' ? customButton(renderProps) : customButton;
  const trigger =
    typeof customButtonTrigger === 'function'
      ? customButtonTrigger({ ...renderProps, disabled })
      : customButtonTrigger;
  // A shared `Button` trigger becomes the popover button itself; wrapping it would nest <button>s.
  const isButtonTrigger = isValidElement(trigger) && trigger.type === Button;

  return (
    <Tippy
      disabled={!tooltip}
      content={tooltip}
      placement={tooltipPlacement}
      className={isTooltipDark ? 'tippy-dark' : ''}>
      <div className={cn('flex items-center gap-x-2', customButtonWrapperClassName)}>
        {button}
        <HeadlessPopoverButton
          {...(isButtonTrigger && { as: Fragment })}
          ref={buttonRef}
          onClick={(e) => {
            if (disabled) return;
            if (!open) onOpen?.();
            onButtonClick?.(e);
          }}
          data-qa={dataQa}
          className={cn(
            !isButtonTrigger && 'p-0',
            disabled && 'cursor-not-allowed',
            customButtonClassName
          )}
          disabled={disabled}>
          {trigger}
        </HeadlessPopoverButton>
      </div>
    </Tippy>
  );
};

export default CustomPopoverTrigger;
